import React from 'react';
import { useTranslation } from 'react-i18next';
import { Section, SectionTitle, InputGroup, InputWrapper, Label, Input } from '../AdvancedSearchBuilder.styled';

const DimensionsSection = ({ width, profile, rim, onChange }) => {
  const { t } = useTranslation();
  return (
    <Section>
      <SectionTitle>{t('dimensions')}</SectionTitle>
      <InputGroup>
        <InputWrapper>
          <Label>{t('widthMm')}</Label>
          <Input type="text" placeholder="205" value={width} onChange={(e) => onChange('width', e.target.value)} />
        </InputWrapper>
        <InputWrapper>
          <Label>{t('profilePercent')}</Label>
          <Input type="text" placeholder="55" value={profile} onChange={(e) => onChange('profile', e.target.value)} />
        </InputWrapper>
        <InputWrapper>
          <Label>{t('rim')}</Label>
          <Input type="text" placeholder="16" value={rim} onChange={(e) => onChange('rim', e.target.value)} />
        </InputWrapper>
      </InputGroup>
    </Section>
  );
};

export default DimensionsSection;

